import React, { useMemo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';

import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';

type CheckboxOptionsProps = Readonly<{
  options: ReadonlyArray<string>;
  selected: ReadonlyArray<string>;
  getId: (value: string) => string;
  onToggle: (value: string) => void;
  formatLabel?: (value: string) => string;
  counts: Readonly<Record<string, number>>;
}>;

export const CheckboxOptions = ({ options, counts, selected, onToggle, getId, formatLabel = value => value }: CheckboxOptionsProps) => {
  const selectedSet = useMemo(() => new Set(selected), [selected]);

  if (!options.length) return null;

  return (
    <>
      {options.map(option => (
        <StyledCheckboxV2
          key={option}
          id={getId(option)}
          isDisabled={!counts[option]}
          onChange={() => onToggle(option)}
          isChecked={selectedSet.has(option)}
        >
          <TextV2
            color="mono14"
            typographyVariant="body1"
          >
            {formatLabel(option)}
            {' '}
            <TextV2
              as="span"
              color="mono10"
              typographyVariant="body1"
            >
              ({counts[option] ?? 0})
            </TextV2>
          </TextV2>
        </StyledCheckboxV2>
      ))}
    </>
  );
};

type CheckboxFacetProps = Omit<CheckboxOptionsProps, 'getId'> &
  Readonly<{
    title: string;
  }>;

export const CheckboxFacet = ({ title, ...optionsProps }: CheckboxFacetProps) => {
  if (!optionsProps.options.length) return null;

  return (
    <FilterFacet title={title}>
      <Flex
        gap={5}
        flexDirection="column"
      >
        <CheckboxOptions
          {...optionsProps}
          getId={option => `car-facet-${title}-${option}`}
        />
      </Flex>
    </FilterFacet>
  );
};
